import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import { Store } from 'redux';
import { Provider } from 'react-redux';
import {
  QueryClient,
  QueryClientProvider,
} from 'react-query';

import * as serviceWorker from './serviceWorker';
import { createMuiTheme, StylesProvider, ThemeProvider } from '@material-ui/core';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';

function importBuildTarget() {
  if (process.env.REACT_APP_BUILD_TARGET === 'editor') {
    return import('./App');
  } else if (process.env.REACT_APP_BUILD_TARGET === 'form') {
    return import('./ReportForm');
  } else {
    return Promise.reject(
      new Error('No such build target: ' + process.env.REACT_APP_BUILD_TARGET)
    );
  }
}

function importStoreTarget(): Promise<{ store: Store }> {
  if (process.env.REACT_APP_BUILD_TARGET === 'editor') {
    return import('./app/store');
  } else if (process.env.REACT_APP_BUILD_TARGET === 'form') {
    return import('./reportState/store');
  } else {
    return Promise.reject(
      new Error('No such build target: ' + process.env.REACT_APP_BUILD_TARGET)
    );
  }
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: Infinity,
    },
  },
});

const theme = createMuiTheme({
  palette: {
    primary: {
      main: '#343d46',
    },
    secondary: {
      main: '#4f5b66',
    },
  },
});
importBuildTarget().then(
  ({ default: Environment }) => {
    importStoreTarget().then(({ store }) => {
      ReactDOM.render(
        <React.StrictMode>
          <StylesProvider injectFirst>
            <QueryClientProvider client={queryClient}>
              <Provider store={store}>
                <DndProvider backend={HTML5Backend}>
                  <ThemeProvider theme={theme}>
                    <Environment />
                  </ThemeProvider>
                </DndProvider>
              </Provider>
            </QueryClientProvider>
          </StylesProvider>
        </React.StrictMode>,
        document.getElementById('root')
      );
    });
  }
  // eslint-disable-next-line react/no-render-return-value
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
